import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Avatar } from '../avatar';
import { ColorIndicator } from '../color-indicator';
import { IconAccountCircle } from '../icon';
import { Chip } from '.';
export const ChipColorIndicator = React.forwardRef(function ChipColorIndicator({ indicatorColor, ...chipProps }, ref) {
    return (_jsx(Chip, { ref: ref, ...chipProps, icon: _jsx(ColorIndicator, { color: indicatorColor, size: 18 }) }));
});
export const ChipAvatarPlaceholder = React.forwardRef(function ChipAvatarPlaceholder(props, ref) {
    return (_jsx(Chip, { ref: ref, ...props, icon: _jsx(IconAccountCircle, { sx: { fontSize: 18 } }) }));
});
export const ChipAvatar = React.forwardRef(function ChipAvatar({ avatarProps, ...chipProps }, ref) {
    return (_jsx(Chip, { ref: ref, ...chipProps, icon: _jsx(Avatar, { ...avatarProps, size: 18 }) }));
});
